import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Topbar from "../Topbar/Topbar";
import { FaStarOfLife } from "react-icons/fa6";
import { Modal, Box, Button } from "@mui/material";
import { ImCross } from "react-icons/im";
import { FiX, FiUpload } from "react-icons/fi"; // Close & Upload icons
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import "./AddEnquiry.css";
import { useEffect } from "react";
import { FaUserEdit } from "react-icons/fa";
import { MdEdit } from "react-icons/md";
import { useRef } from "react";
import _, { assign } from "lodash";
import dayjs from "dayjs";
import MessageBox from "../MessageBox/MessageBox";
import { useSelector } from "react-redux";

export default function AddEnquiry() {
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const staffName = useSelector((state) => state.staffname);
  const currentTime = dayjs().format("hh:mm A"); // Example: "11:42:00 AM"
  const formatDate = (date) => {
    return dayjs(date).format("DD-MM-YYYY");
  };

  const [messageData, setMessageData] = useState(null);

  const permissions = useSelector((state) => state.permissions);
  const [enquiryId, setEnquiryId] = useState(null); // Add this to your component

  const [names, setNames] = useState([]);

  const [staffData, setStaffData] = useState([]);
  const [approvePersons, setApprovePersons] = useState([]); // Example default
  const [isApproveOpen, setIsApproveOpen] = useState(false);
  const approveDropdownRef = useRef(null);
  const [rows, setRows] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [searchTextOtt, setSearchTextOtt] = useState("");
  const [pageRefId, setpageRefId] = useState("");
  const [selectedNames, setSelectedNames] = useState([]);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isEditable, setIsEditable] = useState(true);
  const [selectedNamesOtt, setSelectedNamesOtt] = useState([]);
  const [showMessageBox, setShowMessageBox] = useState(false);
  const [fiberPrice, setFiberPrice] = useState([]);

  const [isEditMode, setIsEditMode] = useState(false); // to track update mode
  const [originalComplaint, setOriginalComplaint] = useState(null);
  const [enquiryName, setenquiryName] = useState("Enquiry");
  const [enquiryTaskStatus, setenquiryTaskStatus] = useState("Open");
  const [isOpen, setIsOpen] = useState(false);
  const [ottData, setOttData] = useState([]);

  const [isOpenOtt, setIsOpenOtt] = useState(false);

  useEffect(() => {
    axios.get(apiUrl + "/get_fibermetersellingcost").then((res) => {
      const data = res.data;
      const fiberData = Array.isArray(data) && data.length > 0 ? data[0] : null;

      setAddEnquiry((prev) => ({
        ...prev,
        enquiryplanDetails: {
          ...prev.enquiryplanDetails,
          enquiryfiberCost: fiberData?.fibermetersellingcost || 0,
        },
      }));
    });
  }, []);

  const dropdownRef = useRef(null);
  const dropdownRefOtt = useRef(null);

  const Id = useSelector((state) => state.id);

  const [searchTerm, setSearchTerm] = useState("");

  // const filteredNames = staffData.filter(staff =>
  //   staff.staffName.toLowerCase().includes(searchTerm.toLowerCase())
  // );
  // Place this in your logic section (above return)
  const filteredNames = staffData
    .filter((staff) => ["Marketing Admin"].includes(staff.designation))
    .filter((staff) =>
      staff.staffName.toLowerCase().includes(searchTerm.toLowerCase())
    );

  const filteredAccountManagers = staffData.filter((staff) =>
    ["Marketing Executive"].includes(staff.designation)
  );
  console.log("Filtered Names:", filteredNames); // Debugging log

  const [routerMaterial, setRouterMaterial] = useState([]);

  const [addEnquiry, setAddEnquiry] = useState({
    leadId: "",
    leadStatus: "open",
    createdDate: "",

    enquirycustomerName: "",
    enquirycontactNum: "",
    enquiryalternateNum: "",
    enquiryaddress: "",
    location: "",
    enquiryleadSource: "",
    // enquiryaccountManager: "",
    enquiryemailId: "",
    enquiryaccountManager: {
      staffName: "",

      _id: "",
    },
    enquiryplanDetails: {
      enquiryplanSpeed: "",
      enquiryplanMonth: "",
      enquiryplanAmount: "",
      enquirystaticIpCost: "",
      enquiryfiberCableMeter: "",
      enquiryinstalationCost: "",
      enquiryrouterModel: "",
      enquiryrouterCost: "",
      enquiryottPackDetails: "",
      enquiryottPrice: [],
      enquiryrouterCost: "",
      enquiryfiberCost: "",
      enquiryothers: "",
      enquiryothersCost: "",
      enquiryadvanceAmount: {
        enquirycurrentDate: "",
        enquiryamount: "",
        enquirypaymentType: "",
        enquiryreferenceNumber: "",
      },
      enquiryadvanceAmountPay: "",
    },
    enquirynextFollowUpDate: "",

    enquiryleadStatus: {
      enquirynotes: "",
      enquiryLeadStatusnextFollowUpDate: "",
    },
  });

  console.log(staffName);

  const convertStringToObject = (locationString) => {
    // Split the input string by a comma and trim whitespace
    const [latitude, longitude] = locationString
      .split(",")
      .map((value) => value.trim());

    // Return the object with parsed latitude and longitude
    return {
      latitude: parseFloat(latitude),
      longitude: parseFloat(longitude),
    };
  };

  const [taskData, setTaskData] = useState({
    taskName: "Enquiry",
    assignedBy: staffName,
    assignDateTime: "",
    // taskType: "Once",
    taskPriority: "Low",
    deadline: "",
    time: "",
    assignedTo: [{}], // Array for multiple selections
    approvePerson: "",
    description: "",
    name: addEnquiry.enquirycustomerName || "",
    leadId: addEnquiry.leadId || "",
    taskStatus: "Open",
  });

  console.log(taskData.name);

  const listView = () => {
    axios
      .post(apiUrl + "viewlead", {})
      .then((res) => {
        setRows(res.data.message);
      })
      .catch((error) => {
        console.error("Error fetching data", error);
      });
  };

  useEffect(() => {
    listView();
  }, []);

  useEffect(() => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");

    const formattedDate = `${year}-${month}-${day}T${hours}:${minutes}`;

    setTaskData((prev) => ({
      ...prev,
      assignDateTime: formattedDate,
    }));
  }, []);

  const [isOpenAssign, setIsOpenAssign] = useState(false);

  const [selectedFile, setSelectedFile] = useState(null);

  const [isOpenAdvancePayment, setIsOpenAdvancePayment] = useState(false);

  // Handle file selection
  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
  };

  const ottOptions = ottData.map((item) => ({
    label: item.ottPackName,
    value: item.ottPackName,
  }));

  useEffect(() => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");

    const formattedDate = `${year}-${month}-${day}T${hours}:${minutes}`;

    setTaskData((prev) => ({
      ...prev,
      assignDateTime: formattedDate,
    }));
  }, []);

  const [isOpenplan, setIsOpenplan] = useState(false);
  const [isOpenConverted, setIsOpenConverted] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    fetch(apiUrl + "generate-lead-id-enquiry")
      .then((res) => res.json())
      .then((data) => {
        console.log("Fetched Lead ID:", data.leadId); // Debugging log

        setAddEnquiry((prev) => ({
          ...prev, // Spread previous state
          leadId: data.leadId, // Update only the leadId field
          createdDate: new Date().toISOString().split("T")[0], // Set today's date
        }));
      })

      .catch((error) => console.error("Error fetching Lead ID:", error));
  }, []);

  // const handlePlanChange = (e) => {
  //   const { name, value } = e.target;

  //   if (name === "enquiryothers") {
  //     // Only allow numbers with up to 2 decimal places
  //     const decimalRegex = /^\d*\.?\d{0,2}$/;
  //     if (value === '' || decimalRegex.test(value)) {
  //       setAddEnquiry((prev) => ({
  //         ...prev,
  //         enquiryplanDetails: {
  //           ...prev.enquiryplanDetails,
  //           [name]: value,
  //         },
  //       }));
  //     }
  //   } else {
  //     // For all other inputs, accept the value directly
  //     setAddEnquiry((prev) => ({
  //       ...prev,
  //       enquiryplanDetails: {
  //         ...prev.enquiryplanDetails,
  //         [name]: value,
  //       },
  //     }));
  //   }
  // };

  const handlePlanChange = (e) => {
    const { name, value } = e.target;

    const convertCurrencyStringToNumber = (str) => {
      const cleaned = str.replace(/[₹,]/g, "");
      return parseFloat(cleaned);
    };

    // Handle OTT pack selection
    if (name === "enquiryottPackDetails") {
      const selectedOtt = ottData.find((ott) => ott.ottDetail === value);
      const ottPrice = selectedOtt
        ? convertCurrencyStringToNumber(selectedOtt.ottPrice)
        : 0;

      setAddEnquiry((prev) => ({
        ...prev,
        enquiryplanDetails: {
          ...prev.enquiryplanDetails,
          enquiryottPackDetails: value,
          enquiryottPrice: [ottPrice],
        
        },
      }));
      return;
    }

    // Handle router selection
    if (name === "enquiryrouterModel") {
      const selectedRouter = routerMaterial.find(
        (r) => r.materialType === value
      );
      const routerCost = selectedRouter ? selectedRouter.sellingCost : 0;

      setAddEnquiry((prev) => ({
        ...prev,
        enquiryplanDetails: {
          ...prev.enquiryplanDetails,
          enquiryrouterModel: value,
          enquiryrouterCost: routerCost,
          routerSellingCost:routerCost
        },
      }));
      return;
    }

    // Allow only decimals in 'enquiryothers'
    if (name === "enquiryothers") {
      const decimalRegex = /^\d*\.?\d{0,2}$/;
      if (value === "" || decimalRegex.test(value)) {
        setAddEnquiry((prev) => ({
          ...prev,
          enquiryplanDetails: {
            ...prev.enquiryplanDetails,
            [name]: value,
          },
        }));
      }
      return;
    }

    // Default handling
    setAddEnquiry((prev) => ({
      ...prev,
      enquiryplanDetails: {
        ...prev.enquiryplanDetails,
        [name]: value,
      },
    }));
  };

  const handleAmountChange = (e) => {
    const { name, value } = e.target;
    setAddEnquiry((prevState) => ({
      ...prevState,
      enquiryplanDetails: {
        ...prevState.enquiryplanDetails,
        enquiryadvanceAmount: {
          ...prevState.enquiryplanDetails.enquiryadvanceAmount,
          [name]: value,
        },
      },
    }));
  };

  const handleLeadChange = (e) => {
    const { name, value } = e.target;
    setAddEnquiry((prevState) => ({
      ...prevState,
      enquiryleadStatus: {
        ...prevState.enquiryleadStatus,
        [name]: value,
      },
    }));
  };

  // const handleChange = (e) => {
  //   const { name, value } = e.target;
  //   setAddEnquiry((prev) => ({
  //     ...prev,
  //     [name]: value,
  //   }));
  // };

  const handleChange = (e) => {
    const { name, value } = e.target;

    // Check if it's a nested field under enquiryplanDetails
    if (name === "enquiryadvanceAmountPay") {
      setAddEnquiry((prev) => ({
        ...prev,
        enquiryplanDetails: {
          ...prev.enquiryplanDetails,
          enquiryadvanceAmountPay: value,
        },
      }));
    } else {
      // If it's a top-level field
      setAddEnquiry((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const [errors, setErrors] = useState({});

  // Validation errors

  useEffect(() => {
    axios
      .get(apiUrl + "get-staff-names")
      .then((res) => {
        if (res.data.message) {
          setNames(res.data.message); // names = array of objects like { _id, staffName }
        }
      })
      .catch((err) => {
        console.log("Error fetching staff names:", err);
      });

    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Fetch staff whole data for dropdown
  useEffect(() => {
    axios
      .post(
        apiUrl + "viewstaff",

        {}
      )
      .then((res) => {
        setStaffData(res.data.message);

        console.log(res.data.message);
      });
  }, [apiUrl]);

  // Toggle dropdown open/close
  const toggleDropdown = () => {
    setIsOpen((prev) => !prev);
  };

  const toggleDropdownOtt = () => {
    console.log("Dropdown clicked");
    setIsOpenOtt((prev) => !prev);
  };

  const handleCheckboxChangeOtt = (staff) => {
    setSelectedNamesOtt((prev) => {
      const exists = prev.find((item) => item._id === staff._id);
      if (exists) {
        // remove staff
        return prev.filter((item) => item._id !== staff._id);
      } else {
        // add staff
        return [...prev, staff];
      }
    });
  };

  const handleCheckboxChange = (staff) => {
    setSelectedNames((prev) => {
      const exists = prev.find((item) => item._id === staff._id);
      if (exists) {
        // remove staff
        return prev.filter((item) => item._id !== staff._id);
      } else {
        // add staff
        return [...prev, staff];
      }
    });
  };

  const displayText =
    selectedNames.length > 0
      ? selectedNames.map((item) => item.staffName).join(", ")
      : "Select names";

  const displayTextOtt =
    selectedNamesOtt.length > 0
      ? selectedNamesOtt.map((item) => item.ottDetail).join(", ")
      : "Select names";
  // State initialization
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Step 1: Validate contact number
    try {
      const contactCheckRes = await axios.post(
        apiUrl + "add-lead-enquiry-contact",
        {
          enquirycontactNum: addEnquiry.enquirycontactNum,
        }
      );

      const { existStatus, id, message } = contactCheckRes.data;

      if (existStatus) {
        Swal.fire({
          title: "Duplicate Enquiry",
          text: message,
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Go to Enquiry",
          cancelButtonText: "Cancel",
        }).then((result) => {
          if (result.isConfirmed) {
            navigate("/view_enquiry", {
              state: { id }, // passing the ID
            });
          }
          // If canceled, do nothing (optional)
        });
        return;
      }
    } catch (error) {
      console.error("Contact check error:", error);
      Swal.fire(
        "Error",
        error.response?.data?.message || "Failed to validate contact number.",
        "error"
      );
      return;
    }

    // Step 2: Validate location
    // let locationObject;
    // try {
    //   locationObject = convertStringToObject(addEnquiry.location);
    //   if (isNaN(locationObject.latitude) || isNaN(locationObject.longitude)) {
    //     throw new Error("Invalid location format");
    //   }
    // } catch (error) {
    //   Swal.fire(
    //     "Error",
    //     "Please enter a valid location in the format: 12.123456, 33.123456",
    //     "error"
    //   );
    //   return;
    // }

    // Step 3: No change detection in edit mode
    if (isEditMode && _.isEqual(addEnquiry, originalComplaint)) {
      Swal.fire("No Changes", "No changes were made to update.", "info");
      return;
    }

    // Step 4: Confirm

    const result = await Swal.fire({
      title: isEditMode ? "Update the changes?" : "Are you sure?",
      showCancelButton: true,
      confirmButtonText: isEditMode ? "Update" : "Submit",
    });

    if (!result.isConfirmed) return;

    const now = new Date();
    const date = now.toLocaleDateString();
    const time = now.toLocaleTimeString();

    const updatedEnquiryDetails = {
      ...addEnquiry,

      location: addEnquiry.location
        ? convertStringToObject(addEnquiry.location)
        : {},
      leadId: addEnquiry.leadId,
      createdBy: {
        staffName: staffName,
        _id: Id,
        time: time,
        date: date,
      },
    };

    if (isEditMode) {
      try {
        await axios.post(
          apiUrl + "update-lead-enquiry",
          updatedEnquiryDetails,
          {
            headers: { "Content-Type": "application/json" },
          }
        );

        Swal.fire("Updated!", "Data updated successfully", "success");
        setIsEditable(false);
        setIsEditMode(false);
      } catch (error) {
        console.error("Update error:", error);
        Swal.fire(
          "Error",
          error.response?.data?.message || "Something went wrong!",
          "error"
        );
      }
    } else {
      axios
        .post(apiUrl + "add-lead-enquiry", updatedEnquiryDetails, {
          headers: { "Content-Type": "application/json" },
        })
        .then((response) => {
          const savedId = response.data.data?._id;
          setEnquiryId(savedId);
          setpageRefId(savedId);

          const formData = new FormData();
          formData.append("pageRefId", savedId);
          formData.append("page", "Enquiry");
          formData.append("colorCode", "#fbdc6e");
          formData.append(
            "description",
            addEnquiry.enquiryleadStatus?.enquirynotes || "No description"
          );
          formData.append("staffPic", "");
   if (selectedFile) {
                formData.append("image", selectedFile);

              }          formData.append("updatesHistory[staff][name]", staffName);
          formData.append("updatesHistory[staff][id]", Id);
          formData.append("updatesHistory[status]", addEnquiry.leadStatus || "Open");

          axios
            .post(apiUrl + "add-message", formData, {
              headers: { "Content-Type": "multipart/form-data" },
            })
            .then(() => {
              console.log("Project update sent.");

              // ✅ Fetch messages after update
              axios
                .get(`${apiUrl}messages/${savedId}`)
                .then((res) => {
                  setMessageData(res.data.data);
                  setShowMessageBox(true); // ✅ Only show message box here!
                })
                .catch((err) => {
                  console.error("Fetching messages failed:", err);
                });

              Swal.fire("Success!", "Enquiry Details Added", "success");
              setIsSubmitted(true);
              setIsEditable(false);
              setIsEditMode(false);
            })

            .then(() => {
              console.log("Project update sent.");

              // ✅ Fetch messages immediately after successful project update
              axios
                .get(`${apiUrl}messages/${savedId}`)
                .then((res) => {
                  setMessageData(res.data.data);
                  console.log("Fetched Messages:", res.data.data);
                })
                .catch((err) => {
                  console.error("Fetching messages failed:", err);
                });

              Swal.fire("Success!", "Enquiry Details Added", "success");
              setIsSubmitted(true);
              setIsEditable(false);
              setIsEditMode(false);
            })
            .catch((err) => {
              console.error("Project update error:", err);
              Swal.fire(
                "Warning",
                "Enquiry saved, but project update failed.",
                "warning"
              );
            });
        })
        .catch((error) => {
          console.error("Enquiry add error:", error);
          Swal.fire(
            "Error",
            error.response?.data?.message || "Something went wrong!",
            "error"
          );
        });
    }
  };

  const handleEdit = (data) => {
    setAddEnquiry(data); // this data must include leadId
    setOriginalComplaint(data);
    setIsEditable(true);
    setIsEditMode(true);
  };

  // Update state handler
const handleInputChange = (field, value) => {
  if (field === 'assignDateTime') {
    const assignDate = new Date(value);
    const deadlineDate = new Date(assignDate.getTime() + 4 * 60 * 60 * 1000);
    const formattedDeadline = deadlineDate.toISOString().slice(0, 16);

    setTaskData(prev => ({
      ...prev,
      assignDateTime: value,
      deadline: formattedDeadline // auto update
    }));
  } else {
    setTaskData(prev => ({
      ...prev,
      [field]: value
    }));
  }
};


 const formatDateTimeLocal = (date) => {
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const day = date.getDate().toString().padStart(2, "0");
  const hours = date.getHours().toString().padStart(2, "0");
  const minutes = date.getMinutes().toString().padStart(2, "0");

  return `${year}-${month}-${day}T${hours}:${minutes}`;
};


useEffect(() => {
  if (taskData.assignDateTime) {
    const assignDate = new Date(taskData.assignDateTime);
    const deadlineDate = new Date(assignDate.getTime() + 4 * 60 * 60 * 1000); // +4 hours
    const formattedDeadline = formatDateTimeLocal(deadlineDate);

    setTaskData(prev => ({
      ...prev,
      deadline: formattedDeadline
    }));
  }
}, [taskData.assignDateTime]);

  //form validation

  const toggleApproveDropdown = () => {
    setIsApproveOpen((prev) => !prev);
  };

  // const handleApproveCheckboxChange = (staff) => {
  //   setApprovePersons(prev => {
  //     const exists = prev.find(item => item._id === staff._id);
  //     if (exists) {
  //       // Remove staff
  //       return prev.filter(item => item._id !== staff._id);
  //     } else {
  //       // Add staff
  //       return [...prev, staff];
  //     }
  //   });
  // };
  const handleApproveCheckboxChange = (staff) => {
    setApprovePersons((prev) => {
      const isSelected = prev.some((item) => item._id === staff._id);
      if (isSelected) {
        return prev.filter((item) => item._id !== staff._id); // remove if unchecked
      } else {
        return [...prev, staff]; // add if checked
      }
    });
  };

  useEffect(() => {
    const defaultApproved = staffData.filter((staff) => {
      return (
        staff.designation &&
        staff.designation.toLowerCase().trim() === "marketing admin"
      );
    });

    setApprovePersons(defaultApproved);
  }, [staffData]);

  const approvePersonText =
    approvePersons.length > 0
      ? approvePersons.map((item) => item.staffName).join(", ")
      : "Select Approve Persons";

  //Email
  const [errorEmail, setErrorEmail] = useState("");
  const handleEmailBlur = () => {
    if (addEnquiry.enquiryemailId.trim() !== "") {
      if (!validateEmail(addEnquiry.enquiryemailId)) {
        setErrorEmail(
          "Please enter a valid email address (e.g., example@domain.com)."
        );
      } else {
        setErrorEmail("");
      }
    } else {
      setErrorEmail(""); // Clear the error if the field is empty
    }
  };

  console.log(addEnquiry);

  const validateEmail = (email) => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.(com|org|net|edu)$/i;
    return emailRegex.test(email);
  };
  const handleSubmitAssignTask = async (e) => {
    e.preventDefault();

    Swal.fire({
      title: "Are you sure you want to create this task?",
      showCancelButton: true,
      confirmButtonText: "Submit",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const now = new Date();
          const day = String(now.getDate()).padStart(2, "0");
          const month = String(now.getMonth() + 1).padStart(2, "0");
          const year = now.getFullYear();
          const updatedDate = `${day}-${month}-${year}`;

          let hours = now.getHours();
          const minutes = String(now.getMinutes()).padStart(2, "0");
          const ampm = hours >= 12 ? "PM" : "AM";
          hours = hours % 12 || 12;
          const updatedTime = `${hours}:${minutes} ${ampm}`;

          const datas = {
            ...taskData,
            assignedBy: {
              staffName: staffName,
              id: Id,
            },
            updatedDate,
            updatedTime,
            assignedTo: selectedNames,
            approvePerson: approvePersons,
            collectionId: enquiryId,
          };

          // Required fields to check
          const requiredFields = [
            "taskName",
            "assignDateTime",
            // "taskPriority",
            // "taskType",
            "deadline",
            "assignedTo",
            "approvePerson",
            "description",
          ];

          // Check for empty fields
          const emptyFields = requiredFields.filter(
            (field) =>
              !datas[field] ||
              (Array.isArray(datas[field]) && datas[field].length === 0)
          );

          if (emptyFields.length > 0) {
            Swal.fire({
              icon: "warning",
              title: "Incomplete Data",
              text: `Please fill all the fields:`,
            });
            return;
          }

          const response = await axios.post(apiUrl + "add-assign-task", datas, {
            headers: { "Content-Type": "application/json" },
          });

          Swal.fire({
            title: "Task Created Successfully!",
            icon: "success",
          }).then(() => {
            navigate("/task");
          });
        } catch (error) {
          console.log(
            "Error submitting data:",
            error.response?.data || error.message
          );
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: error.response?.data?.message || "Something went wrong!",
          });
        }
      }
    });
  };

  useEffect(() => {
    axios.post(apiUrl + "viewott", {}).then((res) => {
      const add_installation = res.data.message || [];
      console.log("Fetched data:", add_installation); // ✅ Check this output

      setOttData(add_installation);
    });
  }, []);

  useEffect(() => {
    axios.get(apiUrl + "/router-selling/all", {}).then((res) => {
      const add_installation = res.data || [];
      console.log("Fetched data:", add_installation); // ✅ Check this output

      setRouterMaterial(add_installation);
    });
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRefOtt.current &&
        !dropdownRefOtt.current.contains(event.target)
      ) {
        setIsOpenOtt(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
      if (
        approveDropdownRef.current &&
        !approveDropdownRef.current.contains(event.target)
      ) {
        setIsApproveOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const getFutureDateTime = () => {
    const now = new Date();
    now.setMinutes(now.getMinutes() + 1); // add 1 minute to current time
    return now.toISOString().slice(0, 16); // returns 'YYYY-MM-DDTHH:MM'
  };

  //  if (!messageData || !Array.isArray(messageData.data)) {
  //   return <p>Loading messages...</p>;
  // }
  return (
    <>
      <Topbar />
      <Container className="mt-1    ">
        <form onSubmit={handleSubmit}>
          <Row>
            <Col>
              <h3>Enquiry</h3>
            </Col>

            <Col className="mx-5 text-end">
              {/* Initial Submit */}
              {/* Initial Submit (Add mode) */}
              {!isSubmitted && !isEditMode && (
                <button
                  className="blue-btn px-4 text-white"
                  value="submit"
                  type="submit"
                >
                  Submit
                </button>
              )}

              {/* After Submit (Edit & Assign buttons) */}
              {isSubmitted && !isEditable && (
                <>
                  {permissions?.Enquiry?.["Add Enquiry"]?.Write && (
                    <button
                      className="black-btn me-2"
                      type="button"
                      onClick={() => {
                        // Store a deep copy of current form data before editing
                        setOriginalComplaint(
                          JSON.parse(JSON.stringify(addEnquiry))
                        );
                        setIsEditable(true);
                        setIsEditMode(true);
                      }}
                    >
                      <MdEdit size={18} /> Edit
                    </button>
                  )}
                  {permissions?.Enquiry?.["Enquiry Task Assign"]?.Write && (
                    <button
                      className=" blue-btn"
                      type="button"
                      onClick={() => {
                        setTaskData((prev) => ({
                          ...prev,
                          name: addEnquiry.enquirycustomerName || "",
                          leadId: addEnquiry.leadId || "",
                        }));
                        setIsOpenAssign(true);
                      }}
                    >
                      <FaUserEdit size={18} /> Assign
                    </button>
                  )}

                  {isOpenAssign && (
                    <div className="overlay3">
                      <div className="modal3">
                        <Container>
                          <div className=" text-end mx-2">
                            <button
                              type="button"
                              className="black-btn mx-3"
                              onClick={() => setIsOpenAssign(false)}
                            >
                              Cancel
                            </button>
                            <button
                              type="button"
                              className=" blue-btn mx-3"
                              onClick={handleSubmitAssignTask}
                            >
                              Submit
                            </button>
                          </div>

                          <Row className="mt-4">
                            <Col xs={12} md={6}>
                              <Row>
                                <Col xs={12} md={6} className="text-start">
                                  <lable>Task Name</lable>
                                  <br />
                                  <input
                                    type="text"
                                    className="form-input"
                                    readOnly
                                    value={taskData.taskName}
                                  />
                                </Col>
                                <Col xs={12} md={6} className="text-start">
                                  <lable>Assign Date/Time</lable>
                                  <br />
                                  <input
                                    type="datetime-local"
                                    value={taskData.assignDateTime}
                                    required
                                    className="form-input"
                                    onChange={(e) =>
                                      handleInputChange(
                                        "assignDateTime",
                                        e.target.value
                                      )
                                    }
                                  />
                                </Col>
                              </Row>
                            </Col>
                            <Col>
                              <Row>
                                {/* <Col xs={12} md={6} className="text-start">
                                  <lable>Task Type</lable>

                                  <br />
                                  <select
                                    onChange={(e) =>
                                      handleInputChange(
                                        "taskType",
                                        e.target.value
                                      )
                                    }
                                    class="dropbtn form-input-select overlay2"
                                  >
                                    <option value="Once">Once</option>
                                    <option value="Daily">Daily</option>
                                    <option value="weekly">Weekly</option>
                                    <option value="Monthy">Monthly</option>
                                    <option value="Custom">Custom</option>
                                  </select>
                                </Col> */}

                                <Col xs={12} md={6} className="text-start">
                                  <lable>Task Priority </lable>
                                  <br />
                                  <select
                                    onChange={(e) =>
                                      handleInputChange(
                                        "taskPriority",
                                        e.target.value
                                      )
                                    }
                                    class="dropbtn form-input-select overlay2"
                                  >
                                    <option value="Low">Low</option>
                                    <option value="High">High</option>
                                    <option value="Immediate">Immediate</option>
                                  </select>
                                </Col>

                               <Col xs={12} md={6} className="text-start">
                                                            <lable>Deadline Date/Time</lable>
                                                            <br />
                                                           <input
                              type="datetime-local"
                              value={taskData.deadline || ""}
                              min={getFutureDateTime()} // optional: restrict past values
                              onChange={(e) =>
                                handleInputChange("deadline", e.target.value)
                              }
                              className="form-input overlay2"
                            />
                            
                                                          </Col>
                                                        
                              </Row>
                            </Col>
                          </Row>

                          <Row>
                            <Col xs={12} md={6}>
                              <Row>
                                <Col xs={12} md={6} className="text-start">
                                  <lable>Lead ID</lable>
                                  <br />
                                  <input
                                    type="text"
                                    value={taskData.leadId}
                                    className="form-input overlay2"
                                    readOnly
                                  />
                                </Col>
                                <Col xs={12} md={6} className="text-start">
                                  <lable>Name </lable>
                                  <br />
                                  <input
                                    type="text"
                                    onChange={(e) =>
                                      handleInputChange("name", e.target.value)
                                    }
                                    style={{ textTransform: "capitalize" }}
                                    className="form-input "
                                    placeholder="Enter Notes "
                                    readOnly
                                    value={taskData.name}
                                  />
                                </Col>
                                {/* <Col xs={12} md={6} className="text-start">
                                  <lable>Deadline </lable>
                                  <br />
                                  <input
                                    type="datetime-local"
                                    onChange={(e) =>
                                      handleInputChange("time", e.target.value)
                                    }
                                    className="form-input overlay2"
                                    placeholder=""
                                  />
                                </Col> */}
                              </Row>
                            </Col>
                            <Col>
                              <Row>
                                <Col xs={12} md={6} className="text-start">
                                  <label>Task Assign To</label>
                                  <br />
                                  <div
                                    ref={dropdownRef}
                                    style={{
                                      position: "relative",
                                      width: "85%",
                                    }}
                                  >
                                    <div
                                      onClick={toggleDropdown}
                                      style={{
                                        padding: "10px",
                                        border: "2px solid #a7a7a7",
                                        borderRadius: "4px",
                                        cursor: "pointer",
                                        backgroundColor: "#fff",
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        marginTop: "10px",
                                      }}
                                    >
                                      <span
                                        style={{
                                          overflow: "hidden",
                                          textOverflow: "ellipsis",
                                          whiteSpace: "nowrap",
                                        }}
                                      >
                                        {displayText}
                                      </span>
                                      <span>{isOpen ? "▲" : "▼"}</span>
                                    </div>

                                    {isOpen && (
                                      <div
                                        style={{
                                          position: "absolute",
                                          top: "100%",
                                          left: 0,
                                          right: 0,
                                          marginTop: "5px",
                                          border: "1px solid #ccc",
                                          borderRadius: "4px",
                                          backgroundColor: "#fff",
                                          boxShadow:
                                            "0 2px 5px rgba(0,0,0,0.2)",
                                          zIndex: 1000,
                                          maxHeight: "250px",
                                          overflowY: "auto",
                                        }}
                                      >
                                        {/* 🔍 Search Input */}
                                        <input
                                          type="text"
                                          placeholder="Search staff..."
                                          value={searchText}
                                          onChange={(e) =>
                                            setSearchText(e.target.value)
                                          }
                                          style={{
                                            width: "95%",
                                            margin: "10px auto",
                                            display: "block",
                                            padding: "8px",
                                            borderRadius: "4px",
                                            border: "1px solid #ccc",
                                          }}
                                        />

                                        {/* Filtered Staff List */}
                                        {staffData
                                          .filter((staff) =>
                                            staff.staffName
                                              .toLowerCase()
                                              .includes(
                                                searchText.toLowerCase()
                                              )
                                          ).length === 0 ? (
                                          <div
                                            style={{
                                              padding: "10px",
                                              color: "#888",
                                              textAlign: "center",
                                            }}
                                          >
                                            No Staffs found
                                          </div>
                                        ) : (
                                          staffData
                                            .filter((staff) =>
                                              staff.staffName
                                                .toLowerCase()
                                                .includes(
                                                  searchText.toLowerCase()
                                                )
                                            )
                                            .map((staff) => (
                                              <label
                                                key={staff._id}
                                                style={{
                                                  display: "flex",
                                                  alignItems: "center",
                                                  padding: "10px",
                                                  cursor: "pointer",
                                                  borderBottom:
                                                    "1px solid #eee",
                                                }}
                                              >
                                                <input
                                                  type="checkbox"
                                                  checked={selectedNames.some(
                                                    (item) =>
                                                      item._id === staff._id
                                                  )}
                                                  onChange={() =>
                                                    handleCheckboxChange(staff)
                                                  }
                                                  style={{
                                                    marginRight: "10px",
                                                  }}
                                                  required
                                                />
                                                {staff.staffName || "(No Name)"}
                                              </label>
                                            ))
                                        )}
                                      </div>
                                    )}
                                  </div>
                                </Col>

                                <Col xs={12} md={6} className="text-start">
                                  <label>Approve Person</label>
                                  <br />
                                  <div
                                    ref={approveDropdownRef}
                                    style={{
                                      position: "relative",
                                      width: "85%",
                                      marginTop: "15px",
                                    }}
                                  >
                                    <div
                                      onClick={toggleApproveDropdown}
                                      style={{
                                        padding: "10px",
                                        border: "2px solid #a7a7a7",
                                        borderRadius: "4px",
                                        cursor: "pointer",
                                        backgroundColor: "#fff",
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        marginTop: "-5px",
                                      }}
                                    >
                                      <span
                                        style={{
                                          overflow: "hidden",
                                          textOverflow: "ellipsis",
                                          whiteSpace: "nowrap",
                                        }}
                                      >
                                        {approvePersonText}
                                      </span>
                                      <span>{isApproveOpen ? "▲" : "▼"}</span>
                                    </div>

                                    {isApproveOpen && (
                                      <div
                                        style={{
                                          position: "absolute",
                                          top: "100%",
                                          left: 0,
                                          right: 0,
                                          marginTop: "5px",
                                          border: "1px solid #ccc",
                                          borderRadius: "4px",
                                          backgroundColor: "#fff",
                                          boxShadow:
                                            "0 2px 5px rgba(0,0,0,0.2)",
                                          zIndex: 1000,
                                          maxHeight: "250px",
                                          overflowY: "auto",
                                        }}
                                      >
                                        {/* 🔍 Search Input */}
                                        <input
                                          type="text"
                                          placeholder="Search staff..."
                                          value={searchTerm}
                                          onChange={(e) =>
                                            setSearchTerm(e.target.value)
                                          }
                                          style={{
                                            width: "100%",
                                            padding: "8px 10px",
                                            borderBottom: "1px solid #ccc",
                                            boxSizing: "border-box",
                                            outline: "none",
                                            border: "none",
                                          }}
                                        />

                                        {/* 🧑‍💼 Filtered Staff List */}
                                        {filteredNames.length === 0 ? (
                                          <div
                                            style={{
                                              padding: "10px",
                                              color: "#888",
                                              textAlign: "center",
                                            }}
                                          >
                                            No staff found
                                          </div>
                                        ) : (
                                          filteredNames.map((staff) => (
                                            <label
                                              key={staff._id}
                                              style={{
                                                display: "flex",
                                                alignItems: "center",
                                                padding: "10px",
                                                cursor: "pointer",
                                                borderBottom: "1px solid #eee",
                                              }}
                                            >
                                              <input
                                                type="checkbox"
                                                required
                                                checked={approvePersons.some(
                                                  (item) =>
                                                    item._id === staff._id
                                                )}
                                                onChange={() =>
                                                  handleApproveCheckboxChange(
                                                    staff
                                                  )
                                                }
                                                style={{ marginRight: "10px" }}
                                              />
                                              {staff.staffName || "(No Name)"}
                                            </label>
                                          ))
                                        )}
                                      </div>
                                    )}
                                  </div>
                                </Col>
                              </Row>
                            </Col>
                          </Row>

                          <Row>
                            <Col xs={12} md={6} className="text-start">
                              <lable>Description</lable>
                              <br />
                              <textarea
                                type="text"
                                onChange={(e) =>
                                  handleInputChange(
                                    "description",
                                    e.target.value
                                  )
                                }
                                style={{
                                  textTransform: "capitalize",
                                  resize: "none",
                                }}
                                className="form-input inputfield-assign "
                                placeholder="Enter Notes "
                              />
                            </Col>
                            <Col>
                              <Row>
                                <Col xs={12} md={6} className="text-start">
                                  <lable>Name </lable>
                                  <br />
                                  <input
                                    type="text"
                                    onChange={(e) =>
                                      handleInputChange("name", e.target.value)
                                    }
                                    style={{ textTransform: "capitalize" }}
                                    className="form-input "
                                    placeholder="Enter Notes "
                                    readOnly
                                    value={taskData.name}
                                  />
                                </Col>

                                <Col xs={12} md={6} className="text-start">
                                  <lable>Task Status </lable>
                                  <br />
                                  <input
                                    type="text"
                                    onChange={(e) =>
                                      handleInputChange(
                                        "taskStatus",
                                        e.target.value
                                      )
                                    }
                                    // style={{ textTransform: "capitalize" }}
                                    style={{
                                      backgroundColor: "#fbdc6e",
                                      color: "rgb(94, 94, 14)",
                                      textTransform: "capitalize",
                                    }}
                                    className="form-input "
                                    readonly
                                    value={taskData.taskStatus}
                                  />
                                </Col>
                              </Row>

                              <Row></Row>
                            </Col>
                          </Row>
                        </Container>
                      </div>
                    </div>
                  )}
                </>
              )}

              {/* Update Submit (Edit mode) */}
              {isEditMode && isEditable && (
                <>
                  <button className=" blue-btn" value="submit" type="submit">
                    Submit
                  </button>

                  <button
                    className="black-btn ms-2"
                    type="button"
                    onClick={() => {
                      // Reset to the original values
                      setAddEnquiry(
                        JSON.parse(JSON.stringify(originalComplaint))
                      );
                      setIsEditable(false);
                      setIsEditMode(false);
                    }}
                    disabled={!isEditable} // Disable cancel button when not in edit mode
                  >
                    Cancel
                  </button>
                </>
              )}
            </Col>
          </Row>

          <div className="border-container1">
            <h6 className="form-head  m-0 text-white  ">Order Details</h6>
          </div>

          <div className="border-container ">
            <Row
              className="text-start lead-id-row  mb-4 mt-4 ms-4 "
              disabled={!isEditable} // Disable cancel button when not in edit mode
            >
              <p className="ps-5 paragraph-lead-id">
                Lead ID -{" "}
                <span className="text-primary " value={addEnquiry.leadId}>
                  {addEnquiry.leadId}
                </span>{" "}
                <span className="lead-start-date">
                  {" "}
                  Lead Started Date -{" "}
                  <span className="text-primary">
                    {formatDate(addEnquiry.createdDate)}
                  </span>
                </span>{" "}
              </p>
            </Row>
            <Row className="ms-3">
              <Col sm={12} md={6} className="text-start ">
                <lable>Customer Name</lable>
                <br />
                <input
                  type="text"
                  style={{ textTransform: "capitalize " }}
                  className="form-input"
                  placeholder="Enter Customer Name"
                  value={addEnquiry.enquirycustomerName} // 👈 using 'customerName'
                  onChange={handleChange}
                  name="enquirycustomerName" // 👈 this name doesn't match the state key
                  disabled={!isEditable}
                />
              </Col>

              <Col>
                <Row>
                  <Col xs={12} md={6} className="text-start">
                    <lable>
                      Contact Number
                      <sup>
                        <FaStarOfLife size={7} />
                      </sup>
                    </lable>
                    <br />
                    <input
                      type="tel"
                      disabled={!isEditable}
                      onKeyDown={(e) => {
                        if (
                          ["e", "E", "+", "-"].includes(e.key) ||
                          (e.key &&
                            !/[0-9]/.test(e.key) &&
                            e.key !== "Backspace" &&
                            e.key !== "ArrowLeft" &&
                            e.key !== "ArrowRight")
                        ) {
                          e.preventDefault();
                        }
                      }}
                      placeholder="Enter Phone Number"
                      className="form-input"
                      value={addEnquiry.enquirycontactNum}
                      onChange={handleChange}
                      name="enquirycontactNum"
                      maxLength={10}
                      required
                    />
                  </Col>

                  <Col xs={12} md={6} className="text-start">
                    <lable>Alternate Number </lable>
                    <br />
                    <input
                      type="tel"
                      disabled={!isEditable}
                      onKeyDown={(e) => {
                        if (
                          ["e", "E", "+", "-"].includes(e.key) ||
                          (e.key &&
                            !/[0-9]/.test(e.key) &&
                            e.key !== "Backspace" &&
                            e.key !== "ArrowLeft" &&
                            e.key !== "ArrowRight")
                        ) {
                          e.preventDefault();
                        }
                      }}
                      value={addEnquiry.enquiryalternateNum}
                      onChange={handleChange}
                      name="enquiryalternateNum"
                      maxLength={10}
                      className="form-input"
                      placeholder="Enter Phone Number"
                    />
                  </Col>
                </Row>
              </Col>
            </Row>

            <Row className="ms-3">
              <Col xs={12} md={6} className="text-start">
                <lable> Address</lable>
                <br />
                <textarea
                  type="text"
                  value={addEnquiry.enquiryaddress}
                  onChange={handleChange}
                  disabled={!isEditable}
                  style={{ textTransform: "capitalize", resize: "none" }}
                  className=" box address-enquiry"
                  placeholder="Enter  Address"
                  name="enquiryaddress"
                />
              </Col>
              <Col>
                <Row>
                  <Col xs={12} md={6} className="text-start">
                    <lable>Location</lable>
                    <br />
                    <input
                      disabled={!isEditable}
                      value={addEnquiry.location}
                      onChange={handleChange}
                      style={{ textTransform: "capitalize" }}
                      className="form-input"
                      type="text"
                      placeholder="Enter Location"
                      name="location"
                    />
                  </Col>
                  <Col xs={12} md={6} className="text-start">
                    <lable>Lead Source</lable>
                    <br />

                    <select
                      value={addEnquiry.enquiryleadSource}
                      onChange={handleChange}
                      class="dropbtn form-input-select"
                      name="enquiryleadSource"
                      disabled={!isEditable}
                    >
                      <option value="">Select</option>

                      {rows.map((data, i) => {
                        return <option>{data.leadSource}</option>;
                      })}
                    </select>
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} md={6} className="text-start">
                    <label>Account Manager</label>
                    <br />

                    <select
                      disabled={!isEditable}
                      value={addEnquiry?.enquiryaccountManager?._id || ""}
                      onChange={(e) => {
                        const selected = names.find(
                          (staff) => staff._id == e.target.value
                        );
                        if (selected) {
                          setAddEnquiry((prev) => ({
                            ...prev,
                            enquiryaccountManager: {
                              _id: selected._id,
                              staffName: selected.staffName?.trim() || "",
                            },
                          }));
                        } else {
                          setAddEnquiry((prev) => ({
                            ...prev,
                            enquiryaccountManager: {
                              _id: "",
                              staffName: "",
                            },
                          }));
                        }
                      }}
                      name="enquiryaccountManager"
                      className="dropbtn form-input-select"
                    >
                      <option value="">Select</option>
                      {Array.isArray(filteredAccountManagers) &&
                        filteredAccountManagers.map((staff) => (
                          <option key={staff._id} value={staff._id}>
                            {staff.staffName?.trim()}
                          </option>
                        ))}
                    </select>
                  </Col>


                  <Col xs={12} md={6} className="text-start">
                    <label></label>
                    <input
                      type="button"
                      disabled={!isEditable}
                      value="Plan details"
                      onClick={() => setIsOpenplan(true)}
                      className="form-input converted-form plandetails-form "
                      onChange={handleChange}
                    />

                    {isOpenplan && (
                      <div className="overlay1">
                        <div className="modal1">
                          <Container>
                            <Row>
                              <Col xs={12} md={6}>
                                <Row>
                                  <Col xs={12} md={6} className="text-start">
                                    <lable>Plan Speed</lable>
                                    <br />
                                    <input
                                      type="text"
                                      value={
                                        addEnquiry?.enquiryplanDetails
                                          ?.enquiryplanSpeed || ""
                                      }
                                      onChange={handlePlanChange}
                                      name="enquiryplanSpeed"
                                      className="form-input overlay2"
                                      placeholder="Enter Plan Speed"
                                    />
                                  </Col>
                                  <Col xs={12} md={6} className="text-start">
                                    <lable>Plan Month</lable>
                                    <br />
                                    <input
                                      type="tel"
                                      value={
                                        addEnquiry?.enquiryplanDetails
                                          ?.enquiryplanMonth
                                      }
                                      onChange={handlePlanChange}
                                      name="enquiryplanMonth"
                                      className="form-input overlay2"
                                      placeholder="Enter Plan Month"
                                    />
                                  </Col>
                                </Row>
                              </Col>
                              <Col>
                                <Row>
                                  <Col xs={12} md={6} className="text-start">
                                    <lable>Plan Amount</lable>
                                    <br />
                                    <input
                                      type="tel"
                                      value={
                                        addEnquiry?.enquiryplanDetails
                                          ?.enquiryplanAmount
                                      }
                                      onChange={handlePlanChange}
                                      name="enquiryplanAmount"
                                      placeholder="Rs"
                                      className="form-input overlay2"
                                    />
                                  </Col>

                                  <Col xs={12} md={6} className="text-start">
                                    <lable>Static Ip Cost </lable>
                                    <br />
                                    <input
                                      type="tel"
                                      value={
                                        addEnquiry?.enquiryplanDetails
                                          ?.enquirystaticIpCost
                                      }
                                      onChange={handlePlanChange}
                                      name="enquirystaticIpCost"
                                      placeholder="Rs"
                                      className="form-input overlay2"
                                    />
                                  </Col>
                                </Row>
                              </Col>
                            </Row>

                            <Row>
                              <Col xs={12} md={6}>
                                <Row>
                                  <Col xs={12} md={6} className="text-start">
                                    <lable>Fiber Cable Meter</lable>
                                    <br />
                                    <input
                                      type="tel"
                                      value={
                                        addEnquiry?.enquiryplanDetails
                                          ?.enquiryfiberCableMeter
                                      }
                                      onChange={handlePlanChange}
                                      name="enquiryfiberCableMeter"
                                      className="form-input overlay2"
                                      placeholder="Enter Meter"
                                    />
                                  </Col>
                                  <Col xs={12} md={6} className="text-start">
                                    <lable>Installation Cost</lable>
                                    <br />
                                    <input
                                      type="tel"
                                      value={
                                        addEnquiry?.enquiryplanDetails
                                          ?.enquiryinstalationCost
                                      }
                                      onChange={handlePlanChange}
                                      name="enquiryinstalationCost"
                                      className="form-input overlay2"
                                      placeholder="Enter installation Cost"
                                    />
                                  </Col>
                                </Row>
                              </Col>
                              <Col>
                                <Row>
                                  <Col xs={12} md={6} className="text-start">
                                    <label>Router Model</label>
                                    <br />
                                    <select
                                      value={
                                        addEnquiry?.enquiryplanDetails
                                          ?.enquiryrouterModel || ""
                                      }
                                      onChange={handlePlanChange}
                                      name="enquiryrouterModel"
                                      className="dropbtn form-input-select overlay2" // ✅ fixed `className`
                                    >
                                      <option value="">Select</option>

                                      {routerMaterial?.map((item) => (
                                        <option
                                          key={item._id}
                                          value={item.materialType}
                                        >
                                          {item.materialType}
                                        </option>
                                      ))}
                                    </select>
                                  </Col>

                                  <Col xs={12} md={6} className="text-start">
                                    <lable>Router Cost </lable>
                                    <br />
                                    <input
                                      type="tel"
                                      value={
                                        addEnquiry?.enquiryplanDetails
                                          ?.enquiryrouterCost
                                      }
                                      onChange={handlePlanChange}
                                      name="enquiryrouterCost"
                                      className="form-input overlay2"
                                      placeholder="Enter installation Cost"
                                    />
                                  </Col>
                                </Row>
                              </Col>
                            </Row>

                            <Row>
                              <Col xs={12} md={6}>
                                <Row>
                                  <Col xs={12} md={6} className="text-start">
                                    <label>OTT Pack Details</label>
                                    <br />
                                    <select
                                      value={
                                        addEnquiry?.enquiryplanDetails
                                          ?.enquiryottPackDetails
                                      }
                                      onChange={(e) =>
                                        handlePlanChange(e, {
                                          name: "enquiryottPackDetails",
                                          value: e.target.value,
                                        })
                                      }
                                      name="enquiryottPackDetails"
                                      className="dropbtn form-input-select overlay2"
                                    >
                                      <option value="">Select</option>
                                      {ottData.map((ott) => (
                                        <option
                                          key={ott._id}
                                          value={ott.ottDetail}
                                        >
                                          {ott.ottDetail}
                                        </option>
                                      ))}
                                    </select>
                                  </Col>

                                  <Col xs={12} md={6} className="text-start">
                                    <lable>Others</lable>
                                    <br />
                                    <input
                                      type="text"
                                      value={
                                        addEnquiry?.enquiryplanDetails
                                          ?.enquiryothers
                                      }
                                      onChange={handlePlanChange}
                                      name="enquiryothers"
                                      style={{ textTransform: "capitalize" }}
                                      className="form-input overlay2"
                                      placeholder="Enter "
                                    />
                                  </Col>
                                </Row>
                              </Col>
                              <Col>
                                <Row>
                                  <Col xs={12} md={6} className="text-start">
                                    <lable>Others Cost</lable>
                                    <br />
                                    <input
                                      type="tel"
                                      value={
                                        addEnquiry?.enquiryplanDetails
                                          ?.enquiryothersCost
                                      }
                                      onChange={handlePlanChange}
                                      name="enquiryothersCost"
                                      placeholder="Rs"
                                      className="form-input overlay2"
                                    />
                                  </Col>

                                  <Col xs={12} md={6} className="text-start">
                                    <lable>Advance Amount </lable>
                                    <br />

                                    <select
                                      className="form-input-select"
                                      name="enquiryadvanceAmountPay"
                                      value={
                                        addEnquiry?.enquiryplanDetails
                                          ?.enquiryadvanceAmountPay || ""
                                      }
                                      onChange={(e) => {
                                        handleChange(e);
                                        if (e.target.value === "Pay") {
                                          setIsOpenAdvancePayment(true);
                                        }
                                      }}
                                    >
                                      <option value="">Select Type</option>
                                      <option value="Unpay">Unpay</option>
                                      <option value="Pay">Pay</option>
                                    </select>

                                    {isOpenAdvancePayment && (
                                      <div className="overlay-advance-payment">
                                        <div className="modal-advance-payment">
                                          <Container>
                                            <Row>
                                              <Col>
                                                {" "}
                                                <h6>Advance Pay</h6>
                                              </Col>
                                              <Col className="text-end">
                                                <span
                                                  style={{
                                                    fontSize: "23px",
                                                    cursor: "pointer",
                                                  }}
                                                  onClick={() =>
                                                    setIsOpenAdvancePayment(
                                                      false
                                                    )
                                                  }
                                                >
                                                  <strong>&times;</strong>
                                                </span>
                                              </Col>
                                            </Row>
                                            <Row>
                                              <Col>
                                                <div>
                                                  <label>Current Date</label>
                                                  <br />
                                                  <input
                                                    className="form-input"
                                                    type="date"
                                                    value={
                                                      addEnquiry
                                                        ?.enquiryplanDetails
                                                        ?.enquiryadvanceAmount
                                                        ?.enquirycurrentDate
                                                    }
                                                    onChange={
                                                      handleAmountChange
                                                    }
                                                    name="enquirycurrentDate"
                                                  />
                                                </div>
                                              </Col>
                                              <Col>
                                                <div>
                                                  <label>Payment Type</label>
                                                  <br />
                                                  <select
                                                    className="form-input-select"
                                                    value={
                                                      addEnquiry
                                                        ?.enquiryplanDetails
                                                        ?.enquiryadvanceAmount
                                                        ?.enquirypaymentType ||
                                                      ""
                                                    }
                                                    onChange={
                                                      handleAmountChange
                                                    }
                                                    name="enquirypaymentType"
                                                  >
                                                    <option value="">
                                                      Select Type
                                                    </option>
                                                    <option value="Private">
                                                      Private
                                                    </option>
                                                    <option value="Technology">
                                                      Technology
                                                    </option>
                                                    <option value="Cash">
                                                      Cash
                                                    </option>
                                                    <option value="Helpdesk">
                                                      Helpdesk
                                                    </option>
                                                    <option value="Others">
                                                      Others
                                                    </option>
                                                  </select>
                                                </div>
                                              </Col>
                                            </Row>
                                            <Row>
                                              <Col>
                                                <div>
                                                  <label>Amount</label>
                                                  <br />
                                                  <input
                                                    className="form-input"
                                                    placeholder="Rs"
                                                    value={
                                                      addEnquiry
                                                        ?.enquiryplanDetails
                                                        ?.enquiryadvanceAmount
                                                        ?.enquiryamount
                                                    }
                                                    onChange={
                                                      handleAmountChange
                                                    }
                                                    name="enquiryamount"
                                                  />
                                                </div>
                                              </Col>
                                              <Col>
                                                <div>
                                                  <label>
                                                    Reference Number
                                                  </label>
                                                  <br />
                                                  <input
                                                    className="form-input"
                                                    placeholder="Enter Reference Number"
                                                    value={
                                                      addEnquiry
                                                        ?.enquiryplanDetails
                                                        ?.enquiryadvanceAmount
                                                        ?.enquiryreferenceNumber
                                                    }
                                                    onChange={
                                                      handleAmountChange
                                                    }
                                                    name="enquiryreferenceNumber"
                                                  />
                                                </div>
                                              </Col>
                                            </Row>

                                            <Row className="text-end mt-5">
                                              <Col className="text-start">
                                                <button
                                                  className="black-btn "
                                                  onClick={() =>
                                                    setIsOpenAdvancePayment(
                                                      false
                                                    )
                                                  }
                                                >
                                                  Cancel
                                                </button>
                                              </Col>
                                              <Col className="text-end">
                                                <button
                                                  className="blue-btn ms-5"
                                                  onClick={() =>
                                                    setIsOpenAdvancePayment(
                                                      false
                                                    )
                                                  }
                                                >
                                                  Submit
                                                </button>
                                              </Col>
                                            </Row>
                                          </Container>
                                        </div>
                                      </div>
                                    )}

                                    {/* </select> */}
                                  </Col>
                                </Row>
                              </Col>
                            </Row>

                            <div className="button-group1">
                              <button
                                type="button"
                                className="black-btn"
                                onClick={() => setIsOpenplan(false)}
                              >
                                Cancel
                              </button>
                              <button
                                type="button"
                                className="ok-btn1"
                                onClick={() => setIsOpenplan(false)}
                              >
                                OK
                              </button>
                            </div>
                          </Container>
                        </div>
                      </div>
                    )}
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row className="ms-3">
              <Col
                xs={12}
                md={6}
                className="text-start update-enquiry-email-ro"
              >
                <lable>Mail ID</lable>
                <br />
                <input
                  value={addEnquiry.enquiryemailId}
                  onChange={handleChange}
                  disabled={!isEditable}
                  type="email"
                  placeholder="Enter Email ID"
                  className="form-input "
                  name="enquiryemailId"
                  pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}"
                  onBlur={handleEmailBlur}
                />
                {errorEmail && <p style={{ color: "red" }}>{errorEmail}</p>}
              </Col>
              <Col>
                <Row>
                  <Col xs={12} md={6} className="text-start">
                    <lable>Next Follow Up Date</lable>
                    <br />
                    <input
                      disabled={!isEditable}
                      className="field form-input"
                      // value={addEnquiry.enquirynextFollowUpDate}
                      value={
                        addEnquiry?.enquiryleadStatus
                          ?.enquiryLeadStatusnextFollowUpDate
                      }
                      readOnly
                      onChange={handleChange}
                      type="date"
                      name="enquirynextFollowUpDate"
                      min={new Date().toISOString().split("T")[0]} // prevents selecting past dates
                    />
                  </Col>
                  <Col
                    xs={12}
                    md={6}
                    className="text-start update-enquiry-email-ro"
                  >
                    <lable>Lead Status</lable>
                    <br />
                    <input
                      style={{
                        backgroundColor: "#fbdc6e",
                        color: "rgb(94, 94, 14)",
                        textTransform: "capitalize",
                      }}
                      type="button"
                      disabled={!isEditable}
                      onClick={() => setIsOpenConverted(true)}
                      className="form-input converted-form"
                      name="enquiryleadStatus"
                      value={addEnquiry.leadStatus}
                    />

                    {isOpenConverted && (
                      <div className="overlay1-converted">
                        <div className="modal1-converted">
                          <Container>
                            <button
                              className="close-btn1"
                              onClick={() => setIsOpenConverted(false)}
                            >
                              <span style={{ fontSize: "20px" }}>
                                {" "}
                                &times;{" "}
                              </span>
                            </button>

                            <div className="open-button border">
                              <h5 style={{ textTransform: "capitalize" }}>
                                {addEnquiry.leadStatus}
                              </h5>
                            </div>

                            <textarea
                              style={{
                                textTransform: "capitalize",
                                resize: "none",
                              }}
                              placeholder="Enter Notes"
                              className="converted-textbox"
                              name="enquirynotes"
                              onChange={handleLeadChange}
                              value={
                                addEnquiry?.enquiryleadStatus?.enquirynotes
                              }
                            />
                            <div className="upload-section">
                              <label className="upload-btn">
                                <FiUpload className="upload-icon" />
                                Upload Image
                                <input
                                  type="file"
                                  accept="image/*"
                                  onChange={handleFileChange}
                                  hidden
                                />
                              </label>
                              {selectedFile && (
                                <p className="file-name">{selectedFile.name}</p>
                              )}
                            </div>

                            <Row>
                              <Col className="date-update-textbox">
                                <label>Next Follow Up Date</label>
                                <br />
                                <input
                                  type="date"
                                  className="field form-input"
                                  value={
                                    addEnquiry?.enquiryleadStatus
                                      ?.enquiryLeadStatusnextFollowUpDate
                                  }
                                  onChange={handleLeadChange}
                                  name="enquiryLeadStatusnextFollowUpDate"
                                  min={new Date().toISOString().split("T")[0]} // only allows today or future
                                />
                              </Col>
                              <Col className="uploadbtn-install">
                                <button
                                  type="button"
                                  className="blue-btn"
                                  onClick={() => setIsOpenConverted(false)}
                                >
                                  Upload
                                </button>
                              </Col>
                            </Row>
                          </Container>
                        </div>
                      </div>
                    )}
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
        </form>

        {showMessageBox && (
          <Row className="container ms-3  me-5">
            <Col md={6} sm={12}>
              <div>
                {messageData &&
                  messageData.map((msg) => (
                    <MessageBox key={msg._id} message={msg} />
                  ))}{" "}
              </div>
            </Col>
            <Col md={6} sm={12} className="">
              {/* Updates History Section */}
              <div className="compact-updates-history">
                <div className="compact-updates-header"> Updates History </div>
                {messageData &&
                  messageData.map((data, index) => (
                    <div className="compact-update text-center" key={index}>
                      <div className="compact-update-date text-center">
                        {new Date(data.updatesHistory.date).toLocaleDateString(
                          "en-GB"
                        ) +
                          " - " +
                          new Date(data.updatesHistory.date)
                            .toLocaleTimeString("en-US", {
                              hour: "2-digit",
                              minute: "2-digit",
                              hour12: true,
                            })
                            .replace(":", ".")}
                      </div>

                      <div className="compact-update-user text-center">
                        {" "}
                        {data.updatesHistory.staff?.name}{" "}
                      </div>
                      <div
                        className={"compact-update-status text-center "}
                        style={{
                          color: data.colorCode ? data.colorCode : "#000000",
                        }}
                      >
                        {data.updatesHistory.status}
                      </div>
                    </div>
                  ))}
              </div>
            </Col>
          </Row>
        )}
      </Container>
    </>
  );
}
